/* @flow */

import { DIRETORIO_IMAGENS_UPLOAD } from '../utils/constants';

const imagemUploadTabela = (url: string) => `
<a href="${DIRETORIO_IMAGENS_UPLOAD}${url}" download="logo.png" target="_blank">
    <img
        style="max-width: 50px;"
        class="img-thumbnail"
        src="${DIRETORIO_IMAGENS_UPLOAD}${url}" />
    </a>
`;

export default imagemUploadTabela;
